import React from "react";

const font = '"DM Sans", sans-serif';

function TableHeader({ columns }) {
  return (
    <tr>
      {columns.map((c) => (
        <th
          key={c}
          style={{
            textAlign: "left",
            padding: "10px 14px",
            fontSize: 11,
            color: "#999999",
            borderBottom: "1px solid rgba(0,0,0,0.06)",
            fontWeight: 500,
            fontFamily: font,
            textTransform: "uppercase",
            letterSpacing: 0.5,
          }}
        >
          {c}
        </th>
      ))}
    </tr>
  );
}

export default TableHeader;
